(() => {
  'use strict';
  const config = window.Plumerive;
  const labels = config.labels;
  const dialog = document.getElementById('CartDrawer');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const container = dialog.querySelector('[data-cart-items]');
  const status = dialog.querySelector('[data-cart-status]');
  let opener, writing = false, loading = false;
  const create = (tag, className, text) => { const node = document.createElement(tag); if (className) node.className = className; if (text != null) node.textContent = text; return node; };
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:config.currency}).format(cents / 100);
  async function request(url, options = {}) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(url, {...options, headers:{Accept:'application/json',...options.headers}, signal:controller.signal});
      const body = await response.json();
      if (!response.ok) throw new Error(body.description || labels.error);
      return body;
    } finally { clearTimeout(timeout); }
  }
  function report(error) { status.textContent = error.name === 'AbortError' ? labels.error : error.message || labels.error; }
  function setBusy(busy) {
    container.setAttribute('aria-busy', String(busy));
    container.querySelectorAll('button').forEach(button => { button.disabled = busy; });
  }
  function render(cart) {
    if (!Array.isArray(cart.items)) throw new Error(labels.error);
    if (cart.currency) config.currency = cart.currency;
    const fragment = document.createDocumentFragment();
    if (!cart.items.length) fragment.append(create('p','cart-empty',labels.empty));
    cart.items.forEach(item => {
      const row = create('article','cart-item');
      const imageLink = create('a'); imageLink.href = item.url; imageLink.tabIndex = -1; imageLink.setAttribute('aria-hidden','true');
      if (item.image) { const img = create('img'); const url = new URL(item.image, location.origin); url.searchParams.set('width','160'); img.src = url.href; img.alt = ''; img.width = 80; img.height = 80; imageLink.append(img); }
      const info = create('div','cart-item-info');
      const title = create('a','cart-item-name',item.product_title); title.href = item.url; info.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') info.append(create('p','cart-item-variant',item.variant_title));
      info.append(create('p','cart-item-price',money(item.final_line_price)));
      const quantity = create('div','qty-row');
      const makeButton = (text, value, label, action) => { const button = create('button','qty-btn',text); button.type = 'button'; button.dataset.cartLine = item.key; button.dataset.cartQuantity = value; button.dataset.action = action; button.setAttribute('aria-label',label + ': ' + item.product_title); return button; };
      quantity.append(makeButton('−', item.quantity - 1, labels.decrease, 'minus'), create('span','qty-val',item.quantity), makeButton('+',item.quantity + 1,labels.increase,'plus'));
      const remove = makeButton(labels.remove,0,labels.remove,'remove'); remove.className = 'cart-item-remove';
      info.append(quantity,remove); row.append(imageLink,info); fragment.append(row);
    });
    container.replaceChildren(fragment);
    document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = cart.item_count; });
    dialog.querySelector('[data-cart-subtotal]').textContent = money(cart.total_price);
  }
  async function refresh() {
    if (loading || writing) return;
    loading = true; status.textContent = labels.loading; setBusy(true);
    try { render(await request(config.routes.cart + '.js')); status.textContent = ''; }
    catch (error) { report(error); const retry = create('button','grid-add',labels.retry); retry.type = 'button'; retry.dataset.cartRetry = ''; status.append(document.createTextNode(' '), retry); }
    finally { loading = false; setBusy(false); }
  }
  function open() {
    if (!dialog.open) { opener = document.activeElement; dialog.showModal(); document.body.classList.add('cart-is-open'); }
    return refresh();
  }
  function close() { if (dialog.open) dialog.close(); }
  dialog.addEventListener('close', () => { document.body.classList.remove('cart-is-open'); if (opener?.isConnected) opener.focus(); });
  dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
  document.addEventListener('click', async event => {
    if (event.target.closest('[data-cart-open]')) { event.preventDefault(); open(); return; }
    if (event.target.closest('[data-cart-close]')) { close(); return; }
    if (event.target.closest('[data-cart-retry]')) { refresh(); return; }
    const button = event.target.closest('[data-cart-line]');
    if (!button || writing || loading) return;
    writing = true; setBusy(true); status.textContent = labels.loading;
    const key = button.dataset.cartLine, action = button.dataset.action;
    try {
      render(await request(config.routes.change + '.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:Number(button.dataset.cartQuantity)})}));
      status.textContent = '';
    } catch (error) { report(error); }
    finally {
      writing = false; setBusy(false);
      const target = [...container.querySelectorAll('[data-cart-line]')].find(node => node.dataset.cartLine === key && node.dataset.action === action);
      if (dialog.open) (target || dialog.querySelector('[data-cart-close]')).focus();
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-ajax-cart-form]');
    if (!form) return;
    event.preventDefault();
    if (writing || loading || !form.reportValidity()) return;
    const button = form.querySelector('[type="submit"]');
    const errorBox = form.querySelector('[data-form-error]');
    const initialText = button.textContent;
    writing = true; button.disabled = true; button.textContent = labels.adding;
    if (errorBox) errorBox.textContent = '';
    form.setAttribute('aria-busy','true');
    const variant = form.querySelector('[data-variant-select]');
    const data = new FormData(form);
    if (variant) variant.disabled = true;
    try {
      await request(config.routes.add + '.js', {method:'POST',body:data});
      writing = false;
      await open();
    } catch (error) { if (errorBox) errorBox.textContent = error.name === 'AbortError' ? labels.error : error.message || labels.error; }
    finally {
      writing = false; button.disabled = false; button.textContent = initialText; form.removeAttribute('aria-busy');
      if (variant) variant.disabled = false;
    }
  });
})();
